import {
    SOCIAL_LOGIN_REQUEST,
    SOCIAL_LOGIN_SUCCESS,
    SOCIAL_LOGIN_FAILURE,
} from '../constant/actionTypes';


export const socialLogin = payload => ({
    type: SOCIAL_LOGIN_REQUEST,
    payload
});

export const socialLoginSuccess = payload => ({
    type: SOCIAL_LOGIN_SUCCESS,
    payload
});

export const socialLoginFailure = payload => ({
    type: SOCIAL_LOGIN_FAILURE,
    payload
});